import { Text } from "@ucl/react-library";
import { Trans, useTranslation } from "react-i18next";
import { Outlet } from "react-router-dom";
import { translationMapping } from "src/utils/translation-mappings";

export const TitleWrapper = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-start gap-10 px-5 py-[30px] md:p-10 max-w-[600px]">
      <div className="flex flex-col gap-2">
        <Text.H1 fontWeight="semi-bold">{t("mfcTitle")}</Text.H1>
        <Text.P size="large">
          <Trans i18nKey="caseLanding.subtitle" components={translationMapping(t)} />
        </Text.P>
      </div>
      <Outlet />
    </div>
  );
};